import type { ReactNode } from "react";
import s from "./ui.module.css";

type Art = "normal" | "dunkel" | "ok" | "warten" | "aus";

/** Kleine Marke mit Wort. Status nie nur als Farbe: Der Text trägt die Bedeutung. */
export function Marke({ art = "normal", children }: { art?: Art; children: ReactNode }) {
  const k = { normal: "", dunkel: s.markeDunkel, ok: s.markeOk, warten: s.markeWarten, aus: s.markeAus }[art];
  return <span className={[s.marke, k].filter(Boolean).join(" ")}>{children}</span>;
}
